module.exports = __webpack_public_path__ + "static/media/404.45526720.png";